import axios from 'axios';

const remove = async (teamId: string) => {
  const { data } = await axios.post(`/team/delete/${teamId}`);
  return data;
};

export default remove;
